export const DEFAULT_ATTACHMENT_CONTEXT =
  "Analiza el documento adjunto e identifica los elementos jurídicos relevantes, riesgos y puntos a considerar.";
export const MAX_AI_ATTACHMENTS = 5;
export const MAX_AI_ATTACHMENT_BYTES = 20 * 1024 * 1024;
export const ATTACHMENT_TRANSFER_LIMIT_MESSAGE =
  "Los archivos superan el límite de transferencia. Intenta con menos archivos o menores.";


export function canSubmitAssist(context, attachments = []) {
  return String(context || "").trim().length >= 10 || attachments.length > 0;
}


export function resolveAssistContext(context, attachments = []) {
  const value = String(context || "").trim();
  return value || (attachments.length ? DEFAULT_ATTACHMENT_CONTEXT : "");
}


export function validateAttachmentSelection(existingCount, files = []) {
  if (existingCount + files.length > MAX_AI_ATTACHMENTS) {
    return { validFiles: [], error: "Máximo 5 archivos por consulta." };
  }
  const oversized = files.find((file) => file.size > MAX_AI_ATTACHMENT_BYTES);
  return {
    validFiles: files.filter((file) => file.size <= MAX_AI_ATTACHMENT_BYTES),
    error: oversized ? `"${oversized.name}" supera los 20 MB.` : "",
  };
}


export function assistHttpError(status, detail = "") {
  if (status === 413) return ATTACHMENT_TRANSFER_LIMIT_MESSAGE;
  return detail || `HTTP ${status}`;
}


export function readFileAsAttachment(file, Reader = FileReader) {
  return new Promise((resolve, reject) => {
    const reader = new Reader();
    reader.onload = () => {
      const encoded = String(reader.result || "").split(",").pop();
      if (!encoded) {
        reject(new Error(`No se pudo codificar "${file.name}".`));
        return;
      }
      resolve({
        name: file.name,
        mime: file.type || "application/octet-stream",
        b64: encoded,
        sizeKB: Math.round(file.size / 1024),
      });
    };
    reader.onerror = () => reject(new Error(`No se pudo leer "${file.name}".`));
    reader.readAsDataURL(file);
  });
}


export function buildStreamingAssistPayload({
  context,
  attachments = [],
  legalAreaMode,
  primaryArea,
  relatedAreas = [],
  customLegalArea,
  draftingClarificationAttempted = false,
  draftingClarificationResponse = "",
  draftingSelectedBranch = "",
  sessionId = "",
  continuationType = "initial",
}) {
  const isManual = legalAreaMode === "manual";
  const payload = {
    context: resolveAssistContext(context, attachments),
    legal_area_mode: legalAreaMode,
    primary_legal_area: isManual ? (primaryArea || null) : null,
    related_legal_areas: isManual ? relatedAreas : [],
    custom_legal_area: (isManual && primaryArea === "other")
      ? (String(customLegalArea || "").trim() || null) : null,
    drafting_clarification_attempted: Boolean(draftingClarificationAttempted),
    continuation_type: continuationType,
  };
  if (sessionId.trim()) {
    payload.session_id = sessionId.trim();
  }
  if (draftingClarificationResponse.trim()) {
    payload.drafting_clarification_response = draftingClarificationResponse.trim();
  }
  if (draftingSelectedBranch.trim()) {
    payload.drafting_selected_branch = draftingSelectedBranch.trim();
  }
  if (attachments.length) {
    payload.attachments = attachments.map((attachment) => ({
      file_b64: attachment.b64,
      file_name: attachment.name,
      mime_type: attachment.mime,
    }));
  }
  return payload;
}